import { render, staticRenderFns } from "./XianRenLingDao.vue?vue&type=template&id=4653b60e&scoped=true&"
import script from "./XianRenLingDao.vue?vue&type=script&lang=js&"
export * from "./XianRenLingDao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4653b60e",
  null
  
)

export default component.exports